// The trailer pop-up: a full-window dark overlay with the video as big as the window allows (16:9). Opened by the home page's
// WATCH TRAILER button. Closes with the × button, the Esc key or a click on the dark area — and the video is removed when it
// closes, so it stops playing. Which video: src/config/trailer.js (YouTube id, or an .mp4).

import { TrailerConfig } from '../config/trailer.js'

let open = null // { el, onKey, opener } while the pop-up is showing

export function isTrailerOpen() { return !!open }

export function closeTrailer() {
  if (!open) return
  const { el, onKey, opener } = open
  open = null
  document.removeEventListener('keydown', onKey, true)
  el.querySelector('[data-trailer-stage]').innerHTML = '' // takes the player out, which stops the sound at once
  el.remove()
  try { opener?.focus?.() } catch { /* the opener may be gone */ }
}

function playerHtml() {
  if (TrailerConfig.mp4) {
    return `<video class="trailer-video" src="${TrailerConfig.mp4}" controls autoplay playsinline></video>`
  }
  const id = encodeURIComponent(TrailerConfig.youtubeId)
  // youtube-nocookie: no tracking cookies until the viewer plays it. autoplay works because opening is a click.
  const src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1&modestbranding=1`
  return `<iframe class="trailer-video" src="${src}" title="Mao Kingdom trailer" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>`
}

export function openTrailer() {
  if (open) return
  if (!TrailerConfig.mp4 && !TrailerConfig.youtubeId) return
  const el = document.createElement('div')
  el.className = 'trailer-modal'
  el.setAttribute('role', 'dialog')
  el.setAttribute('aria-modal', 'true')
  el.setAttribute('aria-label', 'Game trailer')
  el.innerHTML = `
    <button class="trailer-close" type="button" data-trailer-close aria-label="Close the trailer"><span aria-hidden="true">✕</span> CLOSE</button>
    <div class="trailer-frame"><div class="trailer-stage" data-trailer-stage>${playerHtml()}</div></div>
  `
  const onKey = (e) => {
    if (e.key === 'Escape') { e.stopPropagation(); e.preventDefault(); closeTrailer() }
  }
  open = { el, onKey, opener: document.activeElement }
  document.addEventListener('keydown', onKey, true)
  el.addEventListener('click', (e) => { if (e.target === el || e.target.closest('[data-trailer-close]')) closeTrailer() })
  document.body.appendChild(el)
  el.querySelector('[data-trailer-close]').focus()
}
